import { render, staticRenderFns } from "./InfosCollapse.vue?vue&type=template&id=915bfa0c&scoped=true&"
import script from "./InfosCollapse.vue?vue&type=script&lang=ts&"
export * from "./InfosCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./InfosCollapse.vue?vue&type=style&index=0&id=915bfa0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915bfa0c",
  null
  
)

export default component.exports